module.exports = __webpack_public_path__ + "static/img/parallax.13400d43.jpg";